import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultipleFilterProperty } from '../../_model/multiple-filter-property';
import { TableFilters } from '../../_model/table-response/table-filters';
import { DatePipe } from '@angular/common';
import { Constants } from '../../_model/constants';
import { ExportService } from '../../service/export.service';
import { Subscription } from 'rxjs';
import { ClientStateService } from '../navbar/client-state.service';
import { environment } from '../../../environments/environment';
import { User } from '../../_model/user/user';
import { UserService } from '../../service/user.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-report-multiple-input-filter',
  templateUrl: './report-multiple-input-filter.component.html',
  standalone: true,
  imports: [MatFormFieldModule, MatChipsModule, MatIconModule, MatProgressSpinnerModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, MatButtonModule, BsDatepickerModule, MatDialogModule, MatTabsModule, MatToolbarModule, MatListModule, MatSidenavModule, MatExpansionModule, MatSnackBarModule, MatGridListModule, MatCheckboxModule, MatRadioModule],
  styleUrls: ['./report-multiple-input-filter.component.scss']
})
export class ReportMultipleInputFilterComponent implements OnInit {

  @Input() tableFilters!: TableFilters[];
  @Output() selectedFilter = new EventEmitter<FormGroup>();

  clientSubscription!: Subscription;

  localTableFilters!: TableFilters[];
  filterForms!: FormGroup;
  start_date: any;
  end_date: any;
  todayDate: Date | null = null;
  minDate: Date | undefined;
  maxDate: Date | undefined;
  selectedValue: string = 'Date Received';
  bsConfig?: Partial<BsDatepickerConfig>;
  bsRangeValue?: Date[];

  filterArray: Array<MultipleFilterProperty> = [];
  dateFilterSelected = false;
  filterApplied = false;
  removable = true;
  filterAdded = false;
  dateFilterAdded = false;
  excelClicked = false;
  isAddCliecked = false;
  searchClicked = false;
  isLoadingResults = false;


  filterArrayForms!: FormGroup;
  us = false;
  europe = false;
  asia = false;
  workOrders: string[] = [
      'CORRECTIVE',
      'MAINTENANCE',
      'UNDEFINED'
    ];
    workOrdersUk: string[] = [
      'JOBS',
      'MAINTENANCE',
      'CALL OUT',
      'FOLLOW-UP',
      'RECOMMENDATION',
      'NO-ACTION',
      'FIELD BIOLOGIST'
    ];

  constructor(private fb: FormBuilder,
              public datepipe: DatePipe,
              private exportService : ExportService,private userService: UserService,
              private clientStateService: ClientStateService) {
    this.initializeFilter();
  }

  ngOnInit() {
    this.setDateLimits(false);
    this.applyTheme();
    if(environment.region === 'US'){
      this.us = true;
    }
    if(environment.region === 'EUROPE'){
      this.europe = true;
    }
    if(environment.region === 'ASIA'){
      this.asia = true;
    }
    this.localTableFilters = this.tableFilters;
    this.clientSubscription = this.clientStateService.clientStateChanged$.subscribe(() => {
      this.initializeFilter();
      this.filterApplied = false;
      this.dateFilterSelected = false;
      this.filterAdded = false;
      this.dateFilterAdded = false;
      this.filterArray = [];
    });
  }

  applyTheme() {
    this.bsConfig = Object.assign({}, { containerClass: 'theme-blue', displayMonths: 1 });
  }

  checkAndCallMethods() {
    if (this.isAddCliecked) {
      this.addFilter();
    } else if (this.searchClicked) {
      if (this.filterArray.length > 0) {
        this.filterForms.get('multipleFilterarray')!.setValue(this.filterArray);
      }
      this.selectedFilter.emit(this.filterForms);
      //this.initializeFilter();
    } else if (this.excelClicked) {
      if (this.filterArray.length > 0) {
        this.filterForms.get('multipleFilterarray')!.setValue(this.filterArray);
      }
      this.getDatatoExcel(this.filterForms);
    }
  }

  addFilter() {
    let multipleFilterProperty = new MultipleFilterProperty();

      if (this.dateFilterSelected) {
        let filterName = this.filterForms.value.tableFilter.displayName;
        let existDateItem = this.filterArray.filter(item => item.dateValue === filterName);
        if (existDateItem.length < 1) {

          multipleFilterProperty.dispalyName = filterName;
          multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
          multipleFilterProperty.dateValue = filterName;
          multipleFilterProperty.dateBackendName = this.filterForms.value.value;
          
          if (this.bsRangeValue && this.bsRangeValue.length === 2) {
            multipleFilterProperty.origionalStartDateFormat = this.bsRangeValue[0];
            multipleFilterProperty.origionalEndDateFormat = this.bsRangeValue[1];
            if(environment.locale == "en-GB"){
              this.start_date = this.datepipe.transform(this.bsRangeValue[0], Constants.dateFormatEngb);
              this.end_date = this.datepipe.transform(this.bsRangeValue[1], Constants.dateFormatEngb);
            }
            else if(environment.locale == "en-US"){
              this.start_date = this.datepipe.transform(this.bsRangeValue[0], Constants.dateFormaten029);
              this.end_date = this.datepipe.transform(this.bsRangeValue[1], Constants.dateFormaten029);
            }
            multipleFilterProperty.value = this.start_date + " - " + this.end_date;
            this.filterArray.push(multipleFilterProperty);
            this.dateFilterAdded = true;
          }
        } else {
          alert(Constants.dateErrorAlert);
        }

      } else {
        multipleFilterProperty.dispalyName = this.filterForms.value.tableFilter.displayName;
        multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
        multipleFilterProperty.value = this.filterForms.value.value;
        this.filterArray.push(multipleFilterProperty);
      }
    this.filterApplied = true;
    this.initializeFilter();
    this.dateFilterSelected = false;
    this.filterAdded = true;
    this.bsRangeValue = undefined;
  }


  changeValue(value: any) {
    const valStr = typeof value === 'string' ? value : value?.displayName || '';
    const isScheduled = valStr === Constants.scheduledStartDate || valStr.toLowerCase().includes('scheduled');
    const isDateReceived = valStr === Constants.dateReceived || valStr.toLowerCase().includes('date received') || valStr === Constants.date;
    if (isScheduled || isDateReceived) {
      this.setDateLimits(isScheduled);
      this.dateFilterSelected = false;
      this.dateFilterSelected = true;
    } else {
      this.dateFilterSelected = false;
      this.setDateLimits(false);
    }
    this.bsRangeValue = undefined;
  }

  private initializeFilter() {
    this.filterForms = this.fb.group({
      tableFilter: '',
      value: '',
      valuedate: this.fb.group({ start: '', end: '' }),
      multipleFilterarray: []
    });
    this.filterForms.get('tableFilter')?.valueChanges.subscribe((value: any) => {
      this.checkDateFilter(value);
    });
  }

  remove(value: string): void {
    const index = this.filterArray.map(e => e.column).indexOf(value);
    if (index >= 0) {
      this.filterArray.splice(index, 1);
    }

    const dateIndex = this.filterArray.map(e => e.dateValue).indexOf(Constants.date);
    if (dateIndex <= -1) {
      this.dateFilterAdded = false;
    }

    if (this.filterArray.length == 0) {
      this.filterAdded = false;
      this.selectedFilter.emit(this.filterForms);
    }
  }

  get currentDisplayName(): string {
    return this.filterForms?.value?.tableFilter?.displayName || '';
  }

  get isScheduledDate(): boolean {
    const filterName = (this.filterForms?.value?.tableFilter?.displayName || '').toLowerCase();
    const valueName = (typeof this.filterForms?.value?.value === 'string' ? this.filterForms.value.value : '').toLowerCase();
    return filterName.includes('scheduled') || valueName.includes('scheduled');
  }

  setDateLimits(isScheduled: boolean) {
    if (isScheduled) {
      this.minDate = new Date(Constants.scheduledStartActiveDate);
      this.maxDate = undefined;
      this.todayDate = this.minDate;
    } else {
      this.minDate = undefined;
      this.maxDate = new Date();
      this.todayDate = null;
    }
  }

  isArray = () => this.filterForms.value.tableFilter.values && this.filterForms.value.tableFilter.values.length;

  isFilterSet = () => {
    if (this.dateFilterSelected) {
      return !(this.bsRangeValue && this.bsRangeValue.length > 0);
    }
    return !(this.filterForms.value.tableFilter.displayName != "Work Order Number" && this.filterForms.value.value);
  }

  isWONumberFilterApplied = () => {
    if (this.filterForms.value.tableFilter.displayName == "Work Order Number" && this.filterForms.value.value) {
      return true;
    } else if (this.dateFilterAdded) {
      return true;
    } else {
      return false;
    }
  };

  isAnyFilterSet =() =>{
    if (this.filterForms.value.tableFilter && this.filterForms.value.value) {
      return true;
    } else if (this.dateFilterAdded) {
      return true;
    } else {
      return false;
    }
  }

  isExcelClicked() {
    this.excelClicked = true;
    this.searchClicked = false;
    this.isAddCliecked = false;
  }

  isSearchClicked() {
    this.searchClicked = true;
    this.excelClicked = false;
    this.isAddCliecked = false;
  }

  isAddFilterCliecked() { 
    this.isAddCliecked = true;
  }

  reset() {
    this.initializeFilter();
    this.selectedFilter.emit(this.filterForms);
    this.filterApplied = false;
    this.dateFilterSelected = false;
    this.filterAdded = false;
    this.dateFilterAdded = false;
    this.filterArray = [];
    this.bsRangeValue = undefined;
    this.setDateLimits(false);
  }

  checkDateFilter(filter: any) {
    const name = filter?.displayName || '';
    const isScheduled = name === Constants.scheduledStartDate || name.toLowerCase().includes('scheduled');
    const isDateReceived = name === Constants.dateReceived || name === Constants.date;
    if (filter && (isScheduled || isDateReceived)) {
      this.setDateLimits(isScheduled);
      if (isScheduled || !filter.values || filter.values.length === 0) {
        this.dateFilterSelected = true;
      }
    } else {
      this.dateFilterSelected = false;
      this.setDateLimits(false);
    }
    this.bsRangeValue = undefined;
  }

  private getDatatoExcel(formValues : FormGroup) {
    this.isLoadingResults = true;
    let user: User = this.userService.getUser();
    this.exportService.getDataToExcel(formValues,user.brand).subscribe(response => {
    this.isLoadingResults = false;
    window.open(response.data, "_blank");
    }, () => this.isLoadingResults = false)
  }


}
